import ListItem2 from "./ListItem2"
import ListItem from "./ListItem (2)"

// OptionsForBooking هي قائمة هالكومبوننت

function List2() {
  return (
    <ul>
      <ListItem2 listItem2="Cancellation up to one minute before stay"/>
      <ListItem listItem="Cancellation possible up to 48 hours in advance"/>
      <ListItem listItem="Receive a voucher worth the booking amount (valid for 3 years)*"/>
    </ul>
  )
}

export default List2